// IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt): КАРТА ОБЪЯСНЕНИЙ ОБЛАСТИ «ПАНЕЛИ-МЕНЮ» — components/MenuPanel.vue и её вызовы:
// панель страниц (заголовок стола / иконка), меню страницы, панель задач в шапке (администратор), меню пользователя, ≡ виджета, ≡ таблицы,
// вкладка «Tasks panel» формы стола. Заказ (24.09, дословно): «Когда я навожу на иконку со звёздочкой и нажимаю и держу Alt, то я хочу видеть Tooltip
// для этой звёздочки, который бы говорил не только что это избранное, но и … какую функциональность несёт включение-выключение этой галочки.
// Проанализируй все визуальные элементы … с зажатым Alt я хочу видеть объяснение — что это, зачем это, как это влияет на другие».
//
// Запись реестра — функция (vars, ctx) → { title, what, why, click, now, affects, stored, setting, hotkey, states: { <состояние>: текст } };
// ctx = { state, key }. Строки — английские литералы в t() (словари src/i18n/messages/uk.json / ru.json, правило i18n); подстановка {name}
// из vars делает ядро (utils/uiHelp.js) ПОСЛЕ перевода. Пустые поля не выводятся.
// Тексты — ПО ФАКТУ кода 22–24.09 (не по памяти):
//   · звезда страницы — USER.doc.pages → ws_row.favorites (workspaces.user_defaults_save fav_pages, пуш в центральную базу core.save_user_pages):
//     рейл страниц показывает только избранные + текущую (mainStore.pageRail_rows, fe.ux.favoritesRail);
//   · звезда виджета — page_row.favorites (fav_widgets): ТОЛЬКО отбор «только избранные» меню страницы (уточнение Игоря 22.09: набор открытия — ⧉);
//   · ⧉ — page_row.opens (open_widgets, reset_open_widgets): набор виджетов, открываемых со страницей (scan_widgets_onOpening, fe.ux.favoritesOpen);
//     первое изменение копирует умолчания страницы (mainStore.page_openSet → favorites_toggleOpen);
//   · домик — onOpening строки страницы в USER.doc.pages: бэк ставит active_page при открытии стола без страницы в ссылке (workspaces.py);
//   · звёзды команд — строка '@menus' USER.doc.pages: ключи 'user' | 'page' (общий для меню всех страниц) | 'widget:<сегмент>' | 'grid:<сегмент>';
//     звёзды задач — 'tasks:<id записи стола>' (панель в шапке и вкладка формы — одни пометки);
//   · «только избранные» — localStorage menuPanelFavOnly:<favKey> (этот браузер), первое открытие — вкл., если звёзды есть (MenuPanel._favOnlyInit);
//   · поиск — searchLadder (как чипс поиска грида); текст очищается при закрытии панели (hide), чипсы — нет.
import { t, tn } from '@/i18n'

// ---- общие фразы (функции: t() в момент показа, на текущем языке) ----
const openHow = () => t('Click to open; hovering opens it too when “Open menus on hover” is on in the user menu. While Alt is held, only a click opens it.')   // IE 2026 10 25 / ODOO-345044 (заказ Игоря: меню по наведению — опцией, по умолчанию выкл)
const stPersonal = () => t('Your personal settings on the server: only you see them, on any device.')
const stPersonalWs = () => t('Your personal settings on the server, for this workspace: only you see them, on any device.')
const stPersonalPage = () => t('Your personal settings on the server, for this page: only you see them, on any device.')
const favClick = () => t('Add to favourites or remove from them.')
const favWhy = () => t('With «favourites only» on, the menu shows just the marked items.')
const favStates = () => ({ on: t('In favourites — click to remove'), off: t('Not in favourites — click to add') })
const offFormer = () => t('off: the former drop-down menu')
const setting = (...parts) => parts.filter(Boolean).join('; ')
// IE 2026 09 26 / ODOO-… (заказ Игоря: виды панели страниц): виды панели страниц — общие строки
const viewStates = () => ({ on: t('Selected'), off: t('Click to switch to this view') })
const viewStored = () => t('Remembered in this browser for you and this database.')
const viewSetting = () => setting('fe.ux.pagesPanelViews — ' + t('off: no switch, pages with their widgets'), 'fe.ux.menuPanelFitColumns — ' + t('off: no more columns than usual'))

// ---- ключи по виду панели и пункта (MenuPanel: prop help — вид панели) ----
// вид панели: pages (панель страниц) | page (меню страницы) | tasks (панель задач в шапке) | tasksTab (вкладка формы стола) | user | widget | grid
// (IE 2026 09 28 / ODOO-342342: + useCases — встроенная форма-меню кейсов AttrUseCaseMenu, без кнопки-триггера: в MENU_PANEL_KINDS не входит)
// IE 2026 09 28 / ODOO-342342 (заказ Игоря: меню в правом углу — форма MenuPanel везде): + field — ≡ поля JSON / CSS / многострочного текста / чата (utils/menuPanelHost.js)
export const MENU_PANEL_KINDS = ['pages', 'page', 'tasks', 'tasksTab', 'user', 'widget', 'grid', 'field', 'pm']   // IE 2026 10 26 / ODOO-pending (заказ Игоря 26.10: меню процессной модели — форма меню с группировкой): + pm — форма меню процессной модели

// строка меню страницы — виджет (строка PAGE.attrs с widget / relation_segment), иначе команда (Calc / More …)
const isWidgetRow = (raw) => !!(raw && (raw.widget || (raw.node && raw.node.relation_segment)))

// ключ объяснения звезды: у каждого вида — своё следствие
export function menuPanel_favKey(panel, raw) {
    switch (panel) {
        case 'pages': return 'menuPanel.fav.page'
        case 'page': return isWidgetRow(raw) ? 'menuPanel.fav.widget' : 'menuPanel.fav.pageCommand'
        case 'tasks': case 'tasksTab': return 'menuPanel.fav.task'
        case 'user': return 'menuPanel.fav.userCommand'
        case 'widget': return 'menuPanel.fav.widgetCommand'
        case 'grid': return 'menuPanel.fav.gridCommand'
        case 'useCases': return 'menuPanel.fav.useCase'   // IE 2026 09 28 / ODOO-342342 (Use cases): звезда кейса / пути
        case 'field': return 'menuPanel.fav.fieldCommand'   // IE 2026 09 28 / ODOO-342342
        default: return 'menuPanel.fav'
    }
}
export function menuPanel_btnKey(panel) { return MENU_PANEL_KINDS.includes(panel) && panel !== 'tasksTab' ? 'menuPanel.btn.' + panel : 'menuPanel.btn' }

// вид пункта: page — страница (панель страниц), pagewidget — виджет под страницей, task — запись (панель задач), widget — строка-виджет меню страницы, command
export function menuPanel_itemKind(panel, raw) {
    if (!raw) return ''
    if (raw._page && raw._widget) return 'pagewidget'
    if (raw._page) return 'page'
    if (raw._open && raw._open.id) return 'task'
    if (panel === 'page' && isWidgetRow(raw)) return 'widget'
    return 'command'
}

// ДОПОЛНИТЕЛЬНЫЕ строки подсказки ПУНКТА (к прежним Menu item / Group / Command / ID — MenuPanel._itemTip): что делает клик, особое состояние
// (текущая страница, выключен), откуда оформление строки. f = { link, disabled, current, formatted }. Возвращает { click, now, format } (пустые — нет)
// IE 2026 10 06 / ODOO-341407 (заказ Игоря п.3: параметры в форме-меню): f.param — пункт-параметр (utils/menuParams.menuParam_norm: { type, value, valueTitle }):
// Click — выбрать значение / поставить флажок (применяется сразу), Now — текущее значение (у флажка — включено / выключено)
export function menuPanel_itemRows(panel, raw, f = {}) {
    const kind = menuPanel_itemKind(panel, raw)
    const out = { click: '', now: '', format: '' }
    // IE 2026 09 28 / ODOO-342342 (Use cases): пункт формы-меню кейсов (AttrUseCaseMenu) — что делает клик по виду строки (raw._uc.kind)
    // IE 2026 10 26 / ODOO-pending (заказ Игоря 26.10: меню процессной модели — форма меню с группировкой): строка дерева моделей — переключение модели
    if (panel === 'pm' && raw && raw._pm) {
        if (!f.disabled) out.click = t('Switch to this process model: the data are re-read for it; widgets and filters stay in place.')
        if (f.current) out.now = t('This model is open in this tab')
        return out
    }
    if (panel === 'useCases' && raw && raw._uc) {
        const k = raw._uc.kind
        if (raw._uc.soon) out.click = t('Open the card: this use case is planned, there is nothing to show in the demo yet')
        else if (k === 'docs') out.click = t('Open this section of the user guide in the reader')
        else if (k === 'anchor' || k === 'page' || k === 'widget') out.click = t('Open in demo: go to the workspace and page of this step with its filters')
        else if (k === 'section' || k === 'case' || k === 'path') out.click = t('Open the card of this item as a child widget of this form')
        return out
    }
    if (f.param && !f.disabled) {   // IE 2026 10 06 / ODOO-341407
        out.click = f.param.type === 'select' ? t('Choose a value — it applies at once.') : t('Tick or untick — it applies at once.')
        out.now = f.param.type === 'select' ? String(f.param.valueTitle || '') : (f.param.value ? t('Switched on') : t('Switched off'))
    } else if (f.link && !f.disabled) {
        if (kind === 'page') out.click = t('Go to this page')
        else if (kind === 'pagewidget') out.click = t('Go to the page of the widget — it opens with the page; on the open page — open the widget')
        else if (kind === 'task') out.click = panel === 'tasksTab' ? t('Open the task record as a child widget of this form') : t('Open the task record on the current page')
        else if (kind === 'widget') out.click = t('Open this widget on the page')
        else out.click = t('Run the command')
    }
    if (f.current) out.now = t('This page is open now')
    else if (f.disabled) out.now = (kind === 'task' || panel === 'tasks' || panel === 'tasksTab') ? t('Switched off in the task tree — a click does nothing') : t('Switched off — a click does nothing')
    if (f.formatted) {
        if (panel === 'tasks' || panel === 'tasksTab') out.format = t('Colour and font come from the row of this task in the task tree of the workspace')
        else if (kind === 'page') out.format = t('Colour and font come from the row of this page in the page list of the workspace')
        else if (kind === 'pagewidget' || kind === 'widget') out.format = t('Colour and font come from the row of this widget in the page settings')
        else if (panel === 'page') out.format = t('Colour and font come from the row of this item in the page settings')
        else out.format = t('Colour and font are set in the command definition')
    }
    return out
}

// строка «Now» кнопки задач: число задач с ошибкой последнего запуска (+ их названия)
const tasksNow = (v) => {
    const n = +v.errors || 0
    if (!n) return t('No task failed on its last run')
    return tn(n, '{n} task failed on its last run', '{n} tasks failed on their last run') + (v.failed ? ' — ' + v.failed : '')
}
const hotkeyWhere = (v) => (v.panel === 'user' ? t('Works on any page.') : t('Works while the widget or page it belongs to is active.'))

// ---- реестр области ----
const menuPanel = {
    // кнопки-триггеры панелей (у панели задач — и красный бейдж на ней: pointer-events: none, объяснение — у кнопки)
    'menuPanel.btn': (v) => ({
        title: v.title ? '{title}' : t('Menu'),
        what: t('A menu panel: items grouped in columns.'),
        click: openHow(),
    }),
    'menuPanel.btn.pages': () => ({
        title: t('Pages of the workspace'),
        what: t('All pages of this workspace by groups; the switch in the heading shows pages only, pages with the widgets that open with them, or page previews.'),   // IE 2026 09 26 / ODOO-… (заказ Игоря: виды панели страниц)
        click: openHow() + ' ' + t('In the panel: a page — go to it; a widget under the open page — open it.'),
        affects: t('The star chooses the pages shown in the pages rail on the left; the house — the page that opens first in this workspace.'),
        setting: setting('fe.ux.pagesButtonInTopbar — ' + t('off: the Pages button returns to the top of the pages rail, where a click on it hides or shows the rail'), 'fe.ux.menuHoverOpenMs — ' + t('milliseconds the pointer rests on a header menu button before its menu opens (0: click only)'), 'fe.ux.pagesPanelOnRailToggle — ' + t('on: the panel opens from the button at the top of the pages rail'), 'fe.ux.pagesMenuOnTitle — ' + t('off: the panel opens from an icon next to the page menu'), 'fe.ux.menuPanelPage', 'fe.ux.pagesPanelViews', 'fe.ux.menuPanelFitColumns'),   // IE 2026 09 26 / ODOO-… (заказ Игоря: виды панели страниц)
    }),
    'menuPanel.btn.page': () => ({
        title: t('Page menu'),
        what: t('Widgets, calculations and other commands of this page, grouped as in the page settings.'),
        click: openHow() + ' ' + t('In the panel: a widget — open it on this page; a command — run it.'),
        affects: t('The star (favourites) and ⧉ (opens with the page) are your personal marks.'),
        setting: setting('fe.ux.menuPanelPage — ' + t('off: the former drop-down menus'), 'fe.ux.menuHoverOpenMs — ' + t('milliseconds the pointer rests on a header menu button before its menu opens (0: click only)')),   // IE 2026 10 03 / ODOO-345044 (заказ Игоря: кнопка «Страницы» в шапку, hover-меню с задержкой, скрытие рейки кнопкой в меню)
    }),
    // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p214 єдине меню робочої області — вкладки Меню / Сторінки / Завдання): ⊞ — одна форма меню рабочей области с вкладками Menu / Pages / Tasks (components/WorkspaceMenuForm.vue)
    'menuPanel.btn.workspace': (v) => ({
        title: t('Workspace menu'),
        // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p225 єдине меню робочої області, етап 2): вкладка Workspace, виды Pages, форма на названии стола (v.onTitle — клик по названию; наведение не открывает)
        what: t('One menu for the workspace: the Workspace tab — workspace and page commands (settings, page and filter variants); the Menu tab — widgets, sources, calculations and other commands of this page; the Pages tab — all pages of the workspace as a list, with their widgets or as previews; the Tasks tab — its task tree.'),
        click: (v && v.onTitle ? t('Click the workspace name to open the menu.') : openHow()) + ' ' + t('It always opens on the Menu tab; switch tabs at the top of the menu. The search looks in the open tab.'),
        affects: t('The star and ⧉ on the Menu tab, the star and the house on the Pages tab are your personal marks.'),
        setting: setting('fe.ux.workspaceMenuTabs — ' + t('off: the former page menu, the Pages button in the top bar and the separate tasks panel'), 'fe.ux.workspaceMenuOnTitle — ' + t('off: the menu opens with its own button next to the workspace name'), 'fe.ux.menuPanelPage', 'fe.ux.menuHoverOpenMs — ' + t('milliseconds the pointer rests on a header menu button before its menu opens (0: click only)')),
    }),
    // IE 2026 09 26 / ODOO-… (замечания Игоря: рейл и шапка) (п. 3.3): панель задач на названии стола (v.onTitle), для всех пользователей (v.allUsers)
    'menuPanel.btn.tasks': (v) => ({
        title: v.onTitle ? t('Workspace name — tasks panel') : t('Tasks panel'),
        what: v.onTitle ? t('The name of the workspace open in this tab; hovering it opens the task tree of this workspace with the status of the last run of each task.')
            : (v.allUsers ? t('The task tree of this workspace with the status of the last run of each task.') : t('The task tree of this workspace with the status of the last run of each task (for administrators).')),
        click: openHow() + ' ' + t('In the panel: a task — open its record on the current page.'),
        now: tasksNow(v),
        affects: v.onTitle ? t('The red badge next to the name counts the tasks whose last run failed.') : t('The red badge on the button counts the tasks whose last run failed.'),
        stored: t('Statuses are read from the task log: when the workspace opens and when the panel opens (if older than a minute); ↻ in the panel re-reads them.'),
        setting: setting('fe.ux.menuHoverOpenMs — ' + t('milliseconds the pointer rests on a header menu button before its menu opens (0: click only)'), 'fe.ux.menuPanelTasks', 'fe.ux.tasksPanelOnTitle', 'fe.ux.tasksPanelAllUsers', 'fe.ux.tasksBarAutoFetch', 'fe.data.tasksBarStaleSec', 'fe.ux.settingsPageInMenu'),   // IE 2026 09 26 / ODOO-… (замечания Игоря: рейл и шапка) · IE 2026 10 28 / ODOO-5800 (заказ Игоря: страница настроек стола — из меню задач, не из списка страниц): + выключатель пункта страницы настроек
    }),
    // IE 2026 10 26 / ODOO-pending (заказ Игоря 26.10: меню процессной модели — форма меню с группировкой)
    'menuPanel.btn.pm': (v) => ({
        title: t('Process model'),
        what: t('The planning model whose data you see. The menu form shows the models as a tree with their What-if branches and snapshots, the scenario commands and the auto-recalculation state.'),
        click: openHow() + ' ' + t('In the panel: a model or a branch — switch to it; a command — run it.'),
        now: v.notCurrent ? t('You are viewing a model other than the database\'s current one — numbers may differ from what colleagues see.') : t('You are on the database\'s current process model.'),
        stored: t('The choice lives in the page address of this tab, not for other users.'),
        setting: setting('fe.ux.pmMenuForm — ' + offFormer(), 'fe.ux.menuHoverOpenMs — ' + t('milliseconds the pointer rests on a header menu button before its menu opens (0: click only)')),
    }),
    'menuPanel.footer.pmList': () => ({
        title: t('Open the full list'),
        what: t('The list of all process models as a tree by parent, with every column.'),
        click: t('Opens the list; pick a model there to switch to it.'),
    }),
    'menuPanel.btn.user': () => ({
        title: t('User menu'),
        what: t('Top bar commands, your account, appearance (theme, tooltips, language, colour and icon schemes), widget commands and tools.'),
        click: openHow() + ' ' + t('In the panel: click an item to run it.'),
        affects: t('Appearance settings apply to you only.'),
        setting: setting('fe.ux.menuPanelUser — ' + offFormer(), 'fe.ux.menuPanelParams', 'fe.ux.menuPanelParamDelayMs'),   // IE 2026 10 06 / ODOO-341407 (заказ Игоря п.3): + выключатель пунктов-параметров и пауза списка
    }),
    'menuPanel.btn.widget': () => ({
        title: t('Widget menu'),
        what: t('Commands of this widget: its command panel, audit, JSON and other actions.'),
        click: openHow() + ' ' + t('In the panel: click a command to run it for this widget.'),
        setting: setting('fe.ux.menuPanelWidget — ' + offFormer(), 'fe.ux.menuPanelParams'),   // IE 2026 10 06 / ODOO-341407 (заказ Игоря п.3): + выключатель пунктов-параметров
    }),
    'menuPanel.btn.grid': () => ({
        title: t('Table menu'),
        what: t('Commands of this table: its command panel and grid actions (export, rows, formatting and others).'),
        click: openHow() + ' ' + t('In the panel: click a command to run it for this table.'),
        setting: 'fe.ux.menuPanelGrid — ' + offFormer(),
    }),
    // IE 2026 09 28 / ODOO-342342 (заказ Игоря: меню в правом углу — форма MenuPanel везде): ≡ поля JSON / CSS / многострочного текста / чата
    'menuPanel.btn.field': () => ({
        title: t('Field menu'),
        what: t('Commands of this field: its command panel and field actions (fold levels, JSON depth, CSS editing and others).'),
        click: openHow() + ' ' + t('In the panel: click a command to run it for this field.'),
        setting: 'fe.ux.menuPanelEverywhere — ' + offFormer(),
    }),

    // ряд заголовка панели: что за меню · к чему относится (подзаголовок обрезается «…» — полный текст здесь)
    'menuPanel.title': (v) => ({
        title: v.subtitle ? '{title} · {subtitle}' : '{title}',
        what: t('The heading of the panel: which menu this is and what it belongs to.'),
        now: v.subtitle ? '{subtitle}' : '',
    }),

    // ряд инструментов: «только избранные», ↺ набора открытия, ↻ статусов, поиск
    'menuPanel.favOnly': (v) => ({
        title: t('Favourites only'),
        what: t('A filter of this menu: shows only the items marked with the star and what is under them.'),
        why: t('A long menu becomes a short list of what you use.'),
        click: t('Switch between favourites only and all items.'),
        states: {
            on: t('Only favourites are shown — click to show all'),
            off: t('All items are shown — click to show favourites only'),
            empty: t('No favourites in this menu yet — mark items with the star first'),
        },
        affects: v.panel === 'pages' ? t('Only this list; the open page is always shown. The pages rail on the left follows the stars, not this switch.') : t('Only this list.'),
        stored: t('In this browser only, separately for each menu. Until you switch it, the panel opens with favourites only when there are any.'),
    }),
    'menuPanel.openReset': () => ({
        title: t('Back to the page defaults'),
        what: t('You have your own set of widgets that open with this page.'),
        click: t('Forget your set: the widgets chosen in the page settings open again.'),
        affects: t('The next opening of this page and the widgets listed under it in the pages list of the top bar.'),
        stored: stPersonalPage(),
    }),
    'menuPanel.refresh': (v) => ({
        title: t('Refresh the task statuses'),
        what: t('Re-reads the status of the last run of every task in this panel.'),
        click: t('Read the statuses now.'),
        now: v.refreshNow || '',
        affects: t('The status badges of the tasks and the red badge on the tasks button.'),
        setting: setting('fe.ux.tasksBarAutoFetch', 'fe.data.tasksBarStaleSec'),
    }),
    // IE 2026 09 28 / ODOO-… (заказ Игоря: поиск в формах-меню по статусам): поиск идёт и по статусу пункта (бейдж задачи) — what / how / setting
    'menuPanel.search': () => ({
        title: t('Search in the menu'),
        what: t('Filters the items of this menu as you type — by their names and, where the items carry a status badge (tasks), by the status.'),
        how: t('Words may match different parts of a task: «load error» finds the tasks named «Load…» with the status «Error». A status is also found by its name in another language (for example, in English).'),
        click: t('Type text. Enter — make it a chip (all chips must match); Enter in an empty field — open the first found item; Backspace — remove the last chip; Esc — clear the text (in an empty field — close the panel).'),
        affects: t('Matching as in the table search chip: the whole phrase first, then words in any order, the other keyboard layout, typos.'),
        stored: t('Not saved: the text is cleared when the panel closes; chips stay until you remove them.'),
        setting: 'fe.ux.menuSearchBadges — ' + t('off: the search looks at the item names only'),
    }),
    'menuPanel.chip': () => ({
        title: t('Search chip: {text}'),
        what: t('A search condition: every item shown must also match this text.'),
        click: t('⊗ removes the chip.'),
    }),
    'menuPanel.searchHint': () => ({
        title: t('How the search matched'),
        what: t('Nothing matched exactly, so a softer rule was used.'),
        now: '{hint}',
        why: t('Text typed in the other keyboard layout is converted; with typos the closest items are shown.'),
    }),
    'menuPanel.searchCount': () => ({
        title: t('Found: {n}'),
        what: t('The number of items that match the search and can be clicked.'),
    }),

    // ЗВЕЗДА — у каждого вида своё следствие
    'menuPanel.fav': () => ({
        title: t('Favourite'),
        what: t('Marks the item as your favourite.'),
        why: favWhy(),
        click: favClick(),
        states: favStates(),
        affects: t('Only the «favourites only» filter of this menu.'),
        stored: stPersonal(),
    }),
    'menuPanel.fav.page': () => ({
        title: t('Favourite page'),
        what: t('Marks the page as your favourite in this workspace.'),
        why: t('Keeps the pages rail short: only the pages you need.'),
        click: favClick(),
        states: favStates(),
        affects: t('The pages rail on the left shows only favourite pages and the open one (while at least one page is starred); also the «favourites only» filter of this list.'),
        stored: stPersonalWs(),
        setting: 'fe.ux.favoritesRail — ' + t('off: the rail shows all pages'),
    }),
    'menuPanel.fav.widget': () => ({
        title: t('Favourite widget'),
        what: t('Marks the widget as your favourite on this page.'),
        why: favWhy(),
        click: favClick(),
        states: favStates(),
        affects: t('Only the «favourites only» filter of this menu. Which widgets open with the page is set by ⧉, not by the star.'),
        stored: stPersonalPage(),
    }),
    'menuPanel.fav.pageCommand': () => ({
        title: t('Favourite command'),
        what: t('Marks the command as your favourite in the page menus.'),
        why: favWhy(),
        click: favClick(),
        states: favStates(),
        affects: t('Only the «favourites only» filter; the mark is shared by the menus of all pages.'),
        stored: stPersonal(),
    }),
    'menuPanel.fav.userCommand': () => ({
        title: t('Favourite command'),
        what: t('Marks the command as your favourite in the user menu.'),
        why: favWhy(),
        click: favClick(),
        states: favStates(),
        affects: t('Only the «favourites only» filter of the user menu.'),
        stored: stPersonal(),
    }),
    'menuPanel.fav.widgetCommand': () => ({
        title: t('Favourite command'),
        what: t('Marks the command as your favourite in the widget menu.'),
        why: favWhy(),
        click: favClick(),
        states: favStates(),
        affects: t('Only the «favourites only» filter; the mark is shared by the menus of all widgets of the same type.'),
        stored: stPersonal(),
    }),
    'menuPanel.fav.gridCommand': () => ({
        title: t('Favourite command'),
        what: t('Marks the command as your favourite in the table menu.'),
        why: favWhy(),
        click: favClick(),
        states: favStates(),
        affects: t('Only the «favourites only» filter; the mark is shared by the table menus of all widgets of the same type.'),
        stored: stPersonal(),
    }),
    // IE 2026 09 28 / ODOO-342342 (Use cases): звезда, ✓ «пройдено» и ▶ «Open in demo» формы-меню кейсов (AttrUseCaseMenu)
    'menuPanel.fav.useCase': () => ({
        title: t('Favourite use case'),
        what: t('Marks the use case or path as your favourite.'),
        why: favWhy(),
        click: favClick(),
        states: favStates(),
        affects: t('Only the «favourites only» filter of the use cases menus; the records of the use cases do not change.'),
        stored: t('Your personal marks on the server, for this database: only you see them, on any device.'),
        setting: 'fe.guide.cases — ' + t('off: the use cases menu is hidden'),
    }),
    'menuPanel.done': () => ({
        title: t('Done', null, 'guide'),
        what: t('Marks the use case as done by you — one mark per use case, in every path that includes it.'),
        click: t('Mark as done or remove the mark.'),
        states: { on: t('Done — click to unmark'), off: t('Not done yet — click to mark') },
        affects: t('The progress of the paths that include this use case.'),
        stored: t('Your personal marks on the server, for this database: only you see them, on any device.'),
    }),
    'menuPanel.play': () => ({
        title: t('Open in demo'),
        what: t('Goes to the workspace and page of this use case, sets its filters and opens the widget or record to look at.'),
        why: t('To see the use case in the live demo instead of reading about it.'),
        affects: t('Your filters of that workspace are replaced for the demo and saved; «Restore my filters» in the guide bar brings them back. Nothing is saved to the workspace.'),
        setting: setting('fe.guide.cases', 'fe.guide.chipsOnOpen — ' + t('off: the filters are set after the page has opened')),
    }),
    // IE 2026 09 28 / ODOO-342342: звезда команды ≡ поля — набор 'field:<сегмент>:<тип поля>' (utils/menuPanelHost.menuPanelHost_favKind)
    'menuPanel.fav.fieldCommand': () => ({
        title: t('Favourite command'),
        what: t('Marks the command as your favourite in the field menu.'),
        why: favWhy(),
        click: favClick(),
        states: favStates(),
        affects: t('Only the «favourites only» filter; the mark is shared by the menus of the fields of the same type in widgets of the same type.'),
        stored: stPersonal(),
    }),
    'menuPanel.fav.task': () => ({
        title: t('Favourite task'),
        what: t('Marks the task as your favourite in this workspace.'),
        why: favWhy(),
        click: favClick(),
        states: favStates(),
        affects: t('Only the «favourites only» filter; the same marks are used by the tasks button in the top bar and by the «Tasks panel» tab of the workspace form.'),
        stored: stPersonalWs(),
    }),

    // ⧉ — открывается со страницей (виджет меню страницы); состояние: on | off, vars.custom — действует личный набор
    'menuPanel.open': (v, c) => ({
        title: t('Opens with the page'),
        what: t('Marks the widget to open by itself when this page opens.'),
        why: t('The page opens with the widgets you work with.'),
        click: t('Add the widget to the set that opens with the page or take it out. The first change copies the page settings into your personal set.'),
        now: c.state === 'on'
            ? (v.custom ? t('Opens with the page (your set) — click to take it out') : t('Opens with the page (page settings) — click to take it out'))
            : (c.state === 'off' ? t('Does not open with the page — click to add') : ''),
        affects: t('The next opening of this page and the widgets listed under it in the pages list of the top bar.'),
        stored: stPersonalPage() + ' ' + t('↺ next to the search returns the page settings.'),
        setting: 'fe.ux.favoritesOpen — ' + t('off: the widgets from the page settings always open'),
    }),
    // домик — страница по умолчанию стола (панель страниц)
    'menuPanel.home': () => ({
        title: t('Default page'),
        what: t('The page that opens first when you open this workspace (without a page in the link).'),
        click: t('Make this page your default page or unmark it.'),
        states: { on: t('Your default page — click to unmark (the workspace default applies)'), off: t('Click to open this page first') },
        affects: t('Only which page opens first in this workspace for you.'),
        stored: stPersonalWs(),
    }),

    // части строки пункта
    'menuPanel.num': () => ({
        title: t('Page number {num}'),
        what: t('The place of the page in the full list of pages of this workspace; it does not change when you star pages or switch between them.'),
        why: t('The same number stands next to the page in the pages rail on the left.'),
    }),
    'menuPanel.hotkey': (v) => ({
        title: t('Keyboard shortcut {hotkey}'),
        what: t('Runs the same command from the keyboard, without opening the menu.') + ' ' + hotkeyWhere(v),
    }),
    'menuPanel.status': (v) => ({
        title: t('Last run: {status}'),
        what: t('The status of the last run of this task, from the task log.'),
        how: t('Type the status in the search field of the panel to find all the tasks with this status.'),   // IE 2026 09 28 / ODOO-… (заказ Игоря: поиск в формах-меню по статусам)
        now: v.detail ? '{detail}' : '',
        affects: t('Tasks whose last run failed are counted in the red badge on the tasks button.'),
        stored: v.panel === 'tasksTab' ? t('Read from the task log when the form is opened or updated.') : t('Read from the task log; ↻ in the panel re-reads it.'),
    }),
    // IE 2026 09 26 / ODOO-… (заказ Игоря: виды панели страниц): переключатель видов в ряду заголовка панели страниц и схема страницы на карточке вида Previews
    'menuPanel.view.pages': () => ({
        title: t('View: pages'),
        what: t('Only the pages of this workspace, by groups — a short list that fits the screen in columns.'),
        click: t('Show the pages without their widgets.'),
        states: viewStates(),
        affects: t('What the pages panel shows; the list of widgets that open with a page stays in its tooltip (Alt).'),
        stored: viewStored(),
        setting: viewSetting(),
    }),
    'menuPanel.view.widgets': () => ({
        title: t('View: pages and widgets'),
        what: t('Pages with the widgets that open with each page (your set or the page settings) under them.'),
        click: t('Show every page with its widgets; a widget under the open page opens it.'),
        states: viewStates(),
        stored: viewStored(),
        setting: viewSetting(),
    }),
    'menuPanel.view.previews': () => ({
        title: t('View: page previews'),
        what: t('A card per page: on top — the icon, number and name of the page with its marks; under them — the layout of the page: the widgets that open with it, where they stand on the page.'),   // IE 2026 09 29 / ODOO-… (заказ Игоря: подпись карточки вверху)
        why: t('To recognise a page by its layout before opening it.'),
        how: t('A name cut with «…» shows its end when you point at it.'),   // IE 2026 09 29 / ODOO-… (заказ Игоря: продолжение обрезанного текста в панели): вид
        click: t('Show the pages as cards with previews.'),
        states: viewStates(),
        affects: t('Built at once from the page settings and your set of widgets opened with the page; widgets show their pictures where they were taken (widget menu ≡ → Update preview).'),   // IE 2026 09 27 / ODOO-… (заказ Игоря: картинки виджетов)
        stored: viewStored(),
        setting: viewSetting(),
    }),
    'menuPanel.preview': (v) => ({
        title: t('Page layout'),
        what: t('Rectangles are the widgets that open with the page, placed as on the page; framed and with a shadow — free (floating) widgets; a picture — what the widget showed when it was taken, otherwise the icon shows the kind of widget.'),   // IE 2026 09 27 / ODOO-… (заказ Игоря: картинки виджетов)
        now: +v.n ? tn(+v.n, '{n} widget opens with the page', '{n} widgets open with the page') : t('No widgets open with this page'),
        how: t('A name cut with «…» shows its end when you point at it.'),   // IE 2026 09 29 / ODOO-… (заказ Игоря: продолжение обрезанного текста в панели): схема
        affects: t('The ⧉ mark in the page menu changes which widgets open with the page — and this preview.'),
    }),
    // IE 2026 09 26 / ODOO-… (замечание Игоря: поиск в формах-меню): переключатель «Show rows without matches» в ряду поиска и стрелки ‹ › по найденным пунктам
    'menuPanel.showAll': () => ({
        title: t('Show rows without matches'),
        what: t('A switch of the menu search: whether the items that do not match stay in the menu.'),
        why: t('See the found items among all the others — where they are and what is next to them.'),
        click: t('Tick — all items stay in their places: the found ones are highlighted, the rest are dimmed, the first found one is scrolled into view. Untick — the items without matches are hidden.'),
        states: { on: t('Rows without matches are shown.'), off: t('Rows without matches are hidden.') },
        affects: t('The search in every menu panel: pages, page menu, tasks, user menu, widget and table menus, the «Tasks panel» tab. The size of the panel does not change.'),
        // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: живой поиск и чипсы поиска): включено по умолчанию; новый чипс поиска берёт этот выбор, у чипса — свой флажок
        stored: t('Remembered in this browser for you and this database. On until you untick it; a new search chip (Enter) takes this choice and has its own tick in the chip form.'),
        setting: 'fe.ux.menuSearchShowAllToggle — ' + t('off: no switch, items without matches are hidden') + '; fe.ux.menuSearchShowAllDefault — ' + t('off: without your choice the items without matches are hidden') + '; fe.ux.menuSearchChipForm — ' + t('off: plain text chips with one common switch'),
    }),
    'menuPanel.matchPrev': () => ({
        title: t('Previous match'),
        what: t('Marks the previous found item and scrolls to it (before the first — the last).'),
        click: t('Enter in the empty search field opens the marked item; ↑ in the search field does the same as this arrow.'),
    }),
    'menuPanel.matchNext': () => ({
        title: t('Next match'),
        what: t('Marks the next found item and scrolls to it (after the last — the first).'),
        click: t('Enter in the empty search field opens the marked item; ↓ in the search field does the same as this arrow.'),
    }),
    // IE 2026 10 07 / ODOO-5800 (Igor 05.10: «когда чип поиска находит одно значение, то нужна кнопка ">»): Go to the only match — MenuPanel.vue (ровно один найденный пункт; при нескольких — пара ‹ ›)
    'menuPanel.matchGo': () => ({
        title: t('Go to the match'),
        what: t('Marks the only found item and scrolls to it. With several found items this is a pair of arrows ‹ ›.'),
        click: t('Enter in the empty search field opens the marked item; ↓ in the search field does the same as this button.'),
        setting: 'fe.ux.chipNavSingleGo',
    }),
    // IE 2026 09 27 / ODOO-… (заказ Игоря: картинки виджетов): вид меню страницы (List / Widget previews), кнопка «Update page previews», картинка виджета (панель страниц, меню страницы)
    'menuPanel.view.list': () => ({
        title: t('View: list'),
        what: t('The page menu as a list: groups of widgets and commands in columns.'),
        click: t('Show the page menu as a list.'),
        states: viewStates(),
        stored: viewStored(),
        setting: 'fe.ux.widgetPreviews — ' + t('off: no switch, the list only'),
    }),
    'menuPanel.view.widgetPreviews': () => ({
        title: t('View: widget previews'),
        what: t('A card per item of the page menu: widgets show their pictures, commands and widgets without a picture — their icon.'),
        why: t('To find a widget by what it shows.'),
        click: t('Show the page menu as cards with widget pictures.'),
        states: viewStates(),
        affects: t('Pictures are taken by «Update preview» in the widget menu or «Update page previews» here; a missing picture is taken automatically when the widget is open and you are idle.'),
        stored: viewStored(),
        setting: 'fe.ux.widgetPreviews — ' + t('off: no switch, the list only'),
    }),
    'menuPanel.previewsUpdate': () => ({
        title: t('Update page previews'),
        what: t('Takes new pictures of all widgets open on this page, one by one.'),
        why: t('Refresh the pictures of the page previews after the page has changed.'),
        click: t('The interface pauses for a few seconds per widget; a second click stops after the current picture.'),
        states: { on: t('Updating — click to stop after the current picture.'), off: t('Click to update the pictures of the open widgets.') },
        affects: t('Everyone sees the new pictures; widgets that are not open keep their old pictures.'),
        stored: t('On the server, with the time, the author, the chips and the tab of each capture.'),
        setting: 'fe.ux.widgetPreviews',
    }),
    'menuPanel.widgetPreview': (v) => ({
        title: v.title ? '{title}' : t('Widget preview'),
        what: t('A picture of what the widget showed when it was taken (without its header).') + ' ' + t('Chips at capture: {chips}. Tab: {tab}. Size: {size}.'),
        now: '{captured}' + (v.stale ? ' · ' + t('Outdated: {stale}') : ''),
        how: t('To take a new picture: widget menu ≡ → Update preview, or page menu → Update page previews.'),
        affects: t('Everyone sees the same picture.'),
        setting: 'fe.ux.widgetPreviews',
    }),
}

export default menuPanel
